<h1 i18n="@@imprint_headline">
    Imprint
</h1>

<app-cms-block blockId="imprint"></app-cms-block>

<!-- <p>
    Stefanie Hering - Berlin GmbH<br>
    Potsdamer Straße 98<br>
    D-10785 Berlin
</p>
<p>
    <span i18n="@@imprint_label-phone">Phone</span>: +49 (0)30-810 5411-0<br>
    <span i18n="@@imprint_label-fax">Fax</span>: +49 (0)30-810 5411-29<br>
    <a href="mailto:info@heringberlin.com">info@heringberlin.com</a>
</p>
<p><span i18n="@@imprint_label-managing-director">Managing Director</span>: Stefanie Hering</p>
<p><span i18n="@@imprint_label-registered-office">Registered Office</span>: Berlin, Amtsgericht Berlin-Charlottenburg
    HRB 73558</p>
<p><span i18n="@@imprint_label-vat-id">VAT-Id</span>: DE812779844</p>
<p><span i18n="@@imprint_label-eori-no">EORI-No</span>: 4716671</p>
<p i18n="@@imprint_responsibility">
    Responsibility for contents pursuant to § 6 MDStV: Stefanie Hering-Berlin GmbH, represented by the managing director
    Stefanie Hering.
</p>

<p><br/></p>

<p i18n="@@imprint_store-intro">Hering Berlin company store at Porzellanmanufaktur Reichenbach</p>
<p i18n="@@imprint_store-description">The company store only offers factory seconds where all sales are final and
    purchases cannot be exchanged.</p>
<p>
    Fabrikstr. 29<br>
    07629 Reichenbach/Thüringen
</p>
<p>
    <span i18n="@@imprint_label-phone">Phone</span>: +49 (0)36601/935647<br>
    <span i18n="@@imprint_label-fax">Fax</span>: +49 (0)36601/935649<br>
    <a href="mailto:reichenbach@heringberlin.com">reichenbach@heringberlin.com</a>
</p>
<p i18n="@@imprint_opening-times">Opening times:</p>
<p i18n="@@imprint_opening-times-description">
    Monday, Thursday and Friday 10-12 and 14-17 Saturday 10-13 and by appointment
</p>

<p><br/></p>

<p>
    <strong><span i18n="@@imprint_label-data-protection-officer">Data Protection Officer</span>:</strong>
    datenschutz@ib-rahn.de
</p>
<p i18n="@@imprint_eu-regulation-text">
    Required information as per EU Regulation EU No. 524/2013:<br>
    Link to the homepage of the EU-commissions page for online dispute resolution for consumers:
    <a href="http://ec.europa.eu/consumers/odr/" target="_blank">http://ec.europa.eu/consumers/odr/</a>.
    For questions regarding possible dispute resolutions please contact us via: info@heringberlin.com.
</p>
<p i18n="@@imprint_spam-protection">
    Any contact data stated here is based on legal requirements and to be used only to inform the public about the
    operator of this site. Any use of the data for sending unsolicited mail or information is prohibited. The
    operator will us legal action against any unsolicited use of the contact data, e.g. when receiving spam
    eMail or advertising.</p>
<p i18n="@@imprint_third-party-pages">
    The content we provide does contain links to websites of third parties, the content of which we do not have
    any influence on. Due to this we are unable to assume any liability to the contents or statements provided on
    these sites. Any content shown on a third party site is the responsibility of the respective party or their
    operators. Linked pages have been checked for illegal content or activities at the time of linking them. Illegal
    activities have not been found at the time of linking the pages. We cannot reasonably be expected to constantly
    monitor or control the content of linked pages. Should you bring any evidence of a legal infringement to our
    attention we will immediately de-link said content.
</p> -->
